'use client';

import { __awaiter, __generator } from '../../_virtual/_tslib.js';

var API_TRACKING_ANALYSIS = 'log-aggregator/v1/track-job-analysis';
var LAST_3_CHARACTER_JOB_DETAIL = 3; // This number is used for substring pathname
function trackingABJobAnalysis(baseMsUrl, body) {
    return __awaiter(this, void 0, void 0, function () {
        var last3Character, response, ex_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    if (typeof window === 'undefined') {
                        return [2 /*return*/, false];
                    }
                    last3Character = window.location.pathname.substring(window.location.pathname.length - LAST_3_CHARACTER_JOB_DETAIL);
                    // Only tracking from job detail page
                    if (last3Character.indexOf('-jv') < 0 && last3Character.indexOf('-jd') < 0) {
                        return [2 /*return*/, false];
                    }
                    if (!baseMsUrl || baseMsUrl === '') {
                        console.error('Missing URL.');
                        return [2 /*return*/, false];
                    }
                    // Get current time in ISO
                    body.datetime = new Date().toISOString();
                    return [4 /*yield*/, fetch("".concat(baseMsUrl, "/").concat(API_TRACKING_ANALYSIS), {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(body)
                        })];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    _a.sent();
                    return [2 /*return*/, true];
                case 3:
                    ex_1 = _a.sent();
                    console.error(ex_1);
                    return [2 /*return*/, false];
                case 4: return [2 /*return*/];
            }
        });
    });
}

export { trackingABJobAnalysis };
//# sourceMappingURL=applyJob.js.map
